import { IModel, Model } from './Model';

export interface IVisitSalesItemTraitListingModel extends IModel {
  visitSalesItemTraitId: number;
  visitSalesItemId: number;
  traitId: number;
  stringValue: string;
  numberValue: number | undefined;
  decimalValue: number | undefined;
  boolValue: boolean | undefined;
  extendedValue: string;
  traitName: string;
}

export class VisitSalesItemTraitListingModel
  extends Model
  implements IVisitSalesItemTraitListingModel
{
  visitSalesItemTraitId: number;
  visitSalesItemId: number;
  traitId: number;
  stringValue: string;
  numberValue: number | undefined;
  decimalValue: number | undefined;
  boolValue: boolean | undefined;
  extendedValue: string;
  traitName: string;
  constructor(params: IVisitSalesItemTraitListingModel) {
    super(params);
    this.visitSalesItemTraitId = params.visitSalesItemTraitId;
    this.visitSalesItemId = params.visitSalesItemId;
    this.traitId = params.traitId;
    this.stringValue = params.stringValue;
    this.numberValue = params.numberValue;
    this.decimalValue = params.decimalValue;
    this.extendedValue = params.extendedValue;
    this.traitName = params.traitName;
  }
}
